/**
 * @fileoverview Componente responsável por exibir informações complementares do ticket.
 */

import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { Avatar, CardHeader, IconButton, Tooltip, Box, useMediaQuery, useTheme } from "@material-ui/core";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";

import { i18n } from "../../translate/i18n";
import ReassignWhatsAppModal from "../ReassignWhatsAppModal";
import api from "../../services/api";

import { ArrowLeft } from "lucide-react";
const TicketInfo = ({ contact, ticket, onClick, onTicketUpdate }) => {
	const location = useLocation();
	const history = useHistory();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const queryParams = new URLSearchParams(location.search);
	const fromNoResponse = queryParams.get('from') === 'noresponse';
	const [reassignModalOpen, setReassignModalOpen] = useState(false);
	const { user } = ticket
	const [userName, setUserName] = useState('')
	const [contactName, setContactName] = useState('')
	const [participantsCount, setParticipantsCount] = useState(null)

	useEffect(() => {
		if (contact) {
			setContactName(contact.name);
			if(document.body.offsetWidth < 600) {
				if (contact.name.length > 10) {
					const truncadName = contact.name.substring(0, 10) + '...';
					setContactName(truncadName);
				}
			}
		}

		if (user && contact) {
			setUserName(`${i18n.t("messagesList.header.assignedTo")} ${user.name}`);
			if(document.body.offsetWidth < 600) {
				setUserName(`${user.name}`);
			}
		} else if (ticket?.aiAgent && contact) {
			setUserName(`${i18n.t("messagesList.header.assignedTo")} ${ticket.aiAgent.name} (IA)`);
			if(document.body.offsetWidth < 600) {
				setUserName(`${ticket.aiAgent.name} (IA)`);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contact, user, ticket?.aiAgent])

	useEffect(() => {
		let cancelled = false;
		if (!contact?.isGroup || !ticket?.id) {
			setParticipantsCount(null);
			return;
		}
		api.get(`/tickets/${ticket.id}/group-info`)
			.then((res) => {
				if (!cancelled) setParticipantsCount(res.data?.participantsCount ?? null);
			})
			.catch(() => { if (!cancelled) setParticipantsCount(null); });
		return () => { cancelled = true; };
	}, [contact?.isGroup, ticket?.id])

	return (
		<>
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer", padding: isMobile ? '8px 12px' : '8px 16px' }}
				titleTypographyProps={{ noWrap: true, style: { fontSize: '0.95rem', fontWeight: 500 } }}
				subheaderTypographyProps={{ noWrap: true, style: { fontSize: '0.78rem' } }}
				avatar={
					<Box display="flex" alignItems="center" style={{ gap: 4 }}>
						{isMobile && (
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									history.push("/tickets");
								}}
								style={{ marginRight: 4 }}
							>
								<ArrowLeft />
							</IconButton>
						)}
						<Avatar src={contact.profilePicUrl} alt="contact_image" />
					</Box>
				}
				title={
					<Box display="flex" alignItems="center">
						{`${contactName} #${ticket.id}`}
						{fromNoResponse && !ticket.whatsappId && (
							<Tooltip title="Alterar conexão WhatsApp">
								<IconButton
									size="small"
									onClick={(e) => {
										e.stopPropagation();
										setReassignModalOpen(true);
									}}
									style={{ marginLeft: 8 }}
								>
									<SwapHorizIcon fontSize="small" />
								</IconButton>
							</Tooltip>
						)}
					</Box>
				}
				subheader={
					<>
						{contact?.isGroup && participantsCount != null && (
							<span style={{ fontSize: 11, opacity: 0.7, display: "block", lineHeight: 1.2 }}>
								{participantsCount} participantes
							</span>
						)}
						{(ticket.user || ticket.aiAgent) && userName}
					</>
				}
			/>
			<ReassignWhatsAppModal
				open={reassignModalOpen}
				onClose={() => setReassignModalOpen(false)}
				ticketId={ticket.id}
				ticketStatus={ticket.status}
				onSuccess={onTicketUpdate}
			/>
		</>
	);
};

export default TicketInfo;
